/** Extract a property from an object */
export const prop =
	<T, K extends keyof T>(k: K) =>
	(t: T): T[K] =>
		t[k];
